import { setRemoteDefinitions } from '@nx/angular/mf';
import { environment } from './environments/environment';

fetch(
  environment.production
    ? '/remotes/module-federation.manifest.json'
    : '/remotes/module-federation.manifest.dev.json'
)
  .then((res) => res.json())
  .then((definitions) => setRemoteDefinitions(definitions))
  .then(() => import('./bootstrap').catch((err) => console.error(err)));
